<template>
  <div class="container">
    <div class="row">
    <div class="col-md-12 col-sm-12"  style="min-height:90vh; height: auto !important">
        <div style="margin-left: auto; margin-right: auto; width: 700px; position: relative" id="jacketFront"></div>  
        <div style="margin-left: auto; margin-right: auto; width: 700px; position: relative; display: none" id="jacketBack"></div>  
        <div style="margin-left: auto; margin-right: auto; width: 700px; position: relative; display: none" id="jacketLeft"></div>  
        <div style="margin-left: auto; margin-right: auto; width: 700px; position: relative; display: none" id="jacketRight"></div>  
    </div>
    <div class="clearfix"></div>
    <div class="row">
    <div class="col-md-6 text-right" style="position:relative; margin-top:5px">
    <label class="container-radio" :title="'front'">
    <input type="radio" checked="checked" name="radio" @change="showJacket('jacketFront')">
    <span class="checkmark"></span>
    </label>
    <label class="container-radio" :title="'right'">
    <input type="radio" name="radio" @change="showJacket('jacketRight')">
    <span class="checkmark"></span>
    </label>
    <label class="container-radio" :title="'back'">
    <input type="radio" name="radio" @change="showJacket('jacketBack')">
    <span class="checkmark"></span>
    </label>
    <label class="container-radio" :title="'left'">
    <input type="radio" name="radio" @change="showJacket('jacketLeft')">
    <span class="checkmark"></span>
    </label>
    </div>
    <div class="col-md-6 text-left">
        <button class="btn btn-success" @click.prevent="customise()">Re Customize</button>
    </div>
    </div>
    </div>
  </div>
</template>

<script>

import Switches from '@/components/Switches.vue'

import { mapGetters } from 'vuex';
export default {
  name: 'Preview',
  components:{
    
    Switches
  },
  created() {
    let user_key = this.$route.params.user_key;
    this.$store.dispatch('displayPreview',user_key).then( response => {
        $("#jacketFront").append(response.jacketFront)
        $("#jacketBack").append(response.jacketBack)
        $("#jacketRight").append(response.jacketRight)
        $("#jacketLeft").append(response.jacketLeft)
    });
    this.storeSession()
    this.$store.watch( getters => getters.jacketFront)
    this.$store.watch( getters => getters.jacketBack)
    this.$store.watch( getters => getters.jacketLeft)
    this.$store.watch( getters => getters.jacketRight)
    
  },
  computed: {
    ...mapGetters({
      jacketFront: 'jacketFront',
      jacketBack: 'jacketBack',
      jacketLeft: 'jacketLeft',
      jacketRight: 'jacketRight',
    })
  },
  methods: {
    customise(){
         let user_key = this.$route.params.user_key
         this.$router.push('/'+user_key)
    },
    showJacket(type){
        if(type === 'jacketFront'){
            $("#jacketFront").css({'display': 'block'});
            $("#jacketBack").css({'display': 'none'});
            $("#jacketLeft").css({'display': 'none'});
            $("#jacketRight").css({'display': 'none'});
        }else if(type === 'jacketBack'){
            $("#jacketFront").css({'display': 'none'});
            $("#jacketBack").css({'display': 'block'});
            $("#jacketLeft").css({'display': 'none'});
            $("#jacketRight").css({'display': 'none'});
        }else if(type === 'jacketLeft'){
            $("#jacketFront").css({'display': 'none'});
            $("#jacketBack").css({'display': 'none'});
            $("#jacketLeft").css({'display': 'block'});
            $("#jacketRight").css({'display': 'none'});
        }else if(type === 'jacketRight'){
            $("#jacketFront").css({'display': 'none'});
            $("#jacketBack").css({'display': 'none'});
            $("#jacketLeft").css({'display': 'none'});
            $("#jacketRight").css({'display': 'block'});
        }
        
    },
    storeSession(){
      if(this.$session.exists() == false)
      {
        let user_key = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 34);
        console.log(user_key)
        this.$session.set('user_key', user_key)
        sessionStorage.setItem('user_key', user_key)
      }
    }
  },
  mounted() {
      // let user_key = this.$route.params.user_key
      // $("#jacketFront").append(this.jacketFront)
      // $("#jacketBack").append(this.jacketBack)
      // $("#jacketRight").append(this.jacketRight)
      // $("#jacketLeft").append(this.jacketLeft)
  },
}
</script>
<style scoped>
.body{fill: transparent;}
.sleeve{fill:transparent;}
.solid{fill:transparent;}
.pocket{fill:transparent;}
.button{fill:transparent;}
.single_stripe{fill:transparent;}
.double_stripe{fill:transparent;}
.ms-filter{mix-blend-mode: multiply;}

/* custom */

.ms-jacket--front-l {
    left: 57%;
}
.ms-jacket--front-2 {
    right: 58%;
}
.ms-jacket-box-front {
    padding-bottom: 10%;
    top: 30.5%;
    width: 10%;
}

.ms-custom-box {
    position: absolute;
    z-index: 1;
}
.ms-main-holder {
    left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
	-webkit-text-stroke: 5px black;
}

.leftChest_letters_holder {
    font-size: 4.5em;
	font-family: 'Athletic', sans-serif;
}
.leftChest_years_holder {
    font-size: 2.5em;
	font-family: 'Athletic', sans-serif;
}

.leftChest_letters {
	display: none;
 	fill: #fff;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: #000;	
}
.leftChest_years {
	display: none;
 	fill: #fff;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: #000;	
}
.leftChest_logos {
 	display: none;
	width: 100%;		
}


.rightChest_letters_holder {
    font-size: 4.5em;
	font-family: 'Athletic', sans-serif;
}
.rightChest_years_holder {
    font-size: 2.5em;
	font-family: 'Athletic', sans-serif;
}
.rightChest_letters {
	display: none;
 	fill: #fff;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: #000;	
}


.rightChest_name_holder {
    font-size: 1em;
	font-family: 'Athletic', sans-serif;
}

.rightChest_name {
	display: none;
 	fill: #000;	
}

.rightChest_years{
	display: none;
 	fill: #fff;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: #000;	
}
.rightChest_logos {
 	display: none;
	 width: 100%;		
}
   


.backShoulder_holder {
	left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 28%;
    transform: translate(-50%, -50%);
    width: 70%;
	-webkit-text-stroke: 5px black;
	
}

.backShoulder_letters {
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;
  display: none;
  font-size: 2.5em;	
  font-family: 'Athletic', sans-serif;
}

.backShoulder_logos {
    left: 38.5%;
    position: absolute;
    top: 32%;
    width: 40%;
	z-index: 1;
	display: none;
}	

.backShoulderWaist_letters_holder {
	left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    bottom: 8%;
    transform: translate(-50%, -50%);
    width: 70%;
	-webkit-text-stroke: 5px black;
}

.backShoulderWaist_letters {
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;
  display: none;
  font-size: 2em;	
  font-family: 'Athletic', sans-serif;
}

.leftSleeve_box {
    padding-bottom: 10%;
    top: 25%;
    width: 10%;
	right: 44.0%;
	position: absolute;
    z-index: 1;
}
.leftSleeve_container {
    left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
	-webkit-text-stroke: 5px black;
}

.leftSleeve_letters_holder{
  	font-size: 2em;
	font-family: 'Athletic', sans-serif;
}

.leftSleeve_years_holder{
  	font-size: 3em;
	font-family: 'Athletic', sans-serif;
}


.leftSleeve_letters{
  display: none;
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;		
}

.leftSleeve_years{
  display: none;
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;		
}

.leftSleeve_logos{
  display: none;
  width: 100%;
}



.rightSleeve_box {
    padding-bottom: 10%;
    top: 25%;
    width: 10%;
	right: 45.5%;
	position: absolute;
    z-index: 1;
}
.rightSleeve_container {
    left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
	-webkit-text-stroke: 5px black;
}

.rightSleeve_letters_holder{
  	font-size: 2em;
	font-family: 'Athletic', sans-serif;
}

.rightSleeve_years_holder{
  	font-size: 3em;
	font-family: 'Athletic', sans-serif;
}

.rightSleeve_letters{
  display: none;
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;		
}

.rightSleeve_years{
  display: none;
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;		
}

.rightSleeve_logos{
  display: none;
  width: 100%;
}




    /* fancy scroll */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #b82a2f; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}


.container-radio {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  padding-right: 10px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #b3b3b3;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container-radio:hover input ~ .checkmark {
  background-color: #9a9a9a;
}

/* When the radio button is checked, add a blue background */
.container-radio input:checked ~ .checkmark {
  background-color: #b82a2f;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: inline-block;
}

/* Show the indicator (dot/circle) when checked */
.container-radio input:checked ~ .checkmark:after {
  display: inline-block;
}
</style>

